import { AxiosError } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostUsersDownload } from '../../../api/users/users';
import { useOptionsForBinary } from '../../../hooks/api';
import { executeDownload } from '../../../utils/download';
import BlobErrorModal from '../../modules/BlobErrorModal';
import SpinnerModal from '../../modules/SpinnerModal';

// ユーザーダウンロード
function UserDownload() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);      // スピナーモーダルを表示する
  const [displayDownloadError, setDisplayDownloadError] = useState(false);    // エラーダイアログ
  const optionsForBinary = useOptionsForBinary(language);
  const {
    mutateAsync: _downloadAsync,
    isError: downloadIsError,
    error: downloadError,
  } = usePostUsersDownload<AxiosError<Blob>>(optionsForBinary);

  useEffect(() => {
    setDisplayDownloadError(downloadIsError);
  }, [downloadIsError]);

  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    const response = await _downloadAsync();
    if (response.status === 200) {
      executeDownload(response);
      setDisplaySpinnerModal(false);
    } else {
      setDisplaySpinnerModal(false);
    }
  }, [_downloadAsync]);

  return (
    <>
      <a href="#download" onClick={() => downloadAsync()}>
        <i className="fa-solid fa-download" />
        {t('ダウンロード')}
      </a>
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && (
        <BlobErrorModal error={downloadError} onClickOk={() => setDisplayDownloadError(false)} />
      )}
    </>
  );
}
export { UserDownload };
